export default __webpack_public_path__ + "static/media/Pin-Dropoff.dc54d992.svg";